var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "registration-component",
      class: {
        "mobile-view": _vm.isMobileView,
        "white-style": _vm.whitedRegForm
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isAuth,
              expression: "!isAuth"
            }
          ],
          staticClass: "rega-form"
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rega-third-auth" },
            [
              _c("p", { staticClass: "form__login-tips" }, [
                _vm._v("Продолжить в одно касание:")
              ]),
              _vm._v(" "),
              _c("third-auth-buttons")
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "rega-tip" }, [_vm._v("Или")]),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isShowForm,
                  expression: "!isShowForm"
                }
              ],
              staticClass: "button button-gradient show-rega-mobile",
              on: { click: _vm.showRegForm }
            },
            [_vm._v("\n            через e-mail\n        ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isShowForm,
                  expression: "!isShowForm"
                }
              ],
              staticClass: "button button-colored show-rega-mobile",
              on: { click: _vm.showLoginForm }
            },
            [_vm._v("\n            я уже зарегистрирован\n        ")]
          ),
          _vm._v(" "),
          _c(
            "form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowForm && !_vm.isShowLoginForm,
                  expression: "isShowForm && !isShowLoginForm"
                }
              ],
              staticClass: "short_rega-form",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.reg($event)
                }
              }
            },
            [
              _c("div", { staticClass: "forms-wrap" }, [
                _c("div", { staticClass: "input-wrap" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rega_firstname,
                          expression: "rega_firstname"
                        }
                      ],
                      staticClass: "input",
                      attrs: {
                        name: _vm.form_id + "_rega_firstname",
                        autocomplete: "off",
                        placeholder: "Ваше имя",
                        type: "text",
                        required: ""
                      },
                      domProps: { value: _vm.rega_firstname },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.rega_firstname = $event.target.value
                          },
                          function($event) {
                            return _vm.clearErrors("firstname")
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "error",
                        class: { show: _vm.serverErrors.firstname }
                      },
                      [
                        _c("p", { staticClass: "form-field__err" }, [
                          _vm._v(_vm._s(_vm.serverErrors.firstname))
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rega_phone,
                          expression: "rega_phone"
                        }
                      ],
                      staticClass: "input masked-phone",
                      attrs: {
                        id: _vm.form_id + "_rega_phone",
                        name: _vm.form_id + "_rega_phone",
                        autocomplete: "off",
                        placeholder: "Мобильный телефон",
                        type: "tel",
                        required: ""
                      },
                      domProps: { value: _vm.rega_phone },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.rega_phone = $event.target.value
                          },
                          function($event) {
                            return _vm.clearErrors("phone")
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "error",
                        class: { show: _vm.serverErrors.phone }
                      },
                      [
                        _c("p", { staticClass: "form-field__err" }, [
                          _vm._v(_vm._s(_vm.serverErrors.phone))
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rega_email,
                          expression: "rega_email"
                        }
                      ],
                      staticClass: "input",
                      attrs: {
                        name: _vm.form_id + "_email",
                        autocomplete: "off",
                        placeholder: "Email",
                        type: "email",
                        required: ""
                      },
                      domProps: { value: _vm.rega_email },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.rega_email = $event.target.value
                          },
                          function($event) {
                            return _vm.clearErrors("email")
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "error",
                        class: { show: _vm.serverErrors.email }
                      },
                      [
                        _c("p", { staticClass: "form-field__err" }, [
                          _vm._v(_vm._s(_vm.serverErrors.email))
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button button-gradient",
                    class: { highlighted: _vm.highlightRegButton },
                    attrs: { disabled: _vm.isRegLoading, type: "submit" }
                  },
                  [_vm._t("buttontext", [_vm._v("зарегистрироваться")])],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-addition-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "button button-colored",
                    attrs: { type: "button" },
                    on: { click: _vm.showLoginForm }
                  },
                  [
                    _vm._v(
                      "\n                    я уже зарегистрирован\n                "
                    )
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowForm && _vm.isShowLoginForm,
                  expression: "isShowForm && isShowLoginForm"
                }
              ],
              staticClass: "short_rega-form"
            },
            [
              _c(
                "form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEmailLogin,
                      expression: "isEmailLogin"
                    }
                  ],
                  staticClass: "forms-wrap",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.sendEmailLink($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "login-input-wrap" }, [
                    _c("div", { staticClass: "form-field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.login_email,
                            expression: "login_email"
                          }
                        ],
                        staticClass: "input",
                        attrs: {
                          name: _vm.form_id + "_login-email",
                          autocomplete: "off",
                          placeholder: "Email",
                          type: "email",
                          id: _vm.form_id + "_login-email",
                          required: ""
                        },
                        domProps: { value: _vm.login_email },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.login_email = $event.target.value
                            },
                            function($event) {
                              return _vm.clearErrors("loginEmail")
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "error",
                          class: { show: _vm.serverErrors.loginEmail }
                        },
                        [
                          _c("p", { staticClass: "form-field__err" }, [
                            _vm._v(_vm._s(_vm.serverErrors.loginEmail))
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "login-description" }, [
                      _vm._v(
                        "На почту будет отправлена временная ссылка для входа."
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "login-buttons" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button button-gradient",
                        attrs: { disabled: _vm.isLoginLoading, type: "submit" }
                      },
                      [
                        _vm._v(
                          "\n                        получить ссылку\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button button-colored",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.isEmailLogin = !_vm.isEmailLogin
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Войти с помощью телефона\n                    "
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isEmailLogin,
                      expression: "!isEmailLogin"
                    }
                  ],
                  staticClass: "forms-wrap",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.initPhoneLogin($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "login-input-wrap" }, [
                    _c("div", { staticClass: "form-field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.login_phone,
                            expression: "login_phone"
                          }
                        ],
                        staticClass: "input masked-phone",
                        attrs: {
                          id: _vm.form_id + "_login-phone",
                          name: _vm.form_id + "_login-phone",
                          autocomplete: "off",
                          placeholder: "Мобильный телефон",
                          type: "tel",
                          required: ""
                        },
                        domProps: { value: _vm.login_phone },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.login_phone = $event.target.value
                            },
                            function($event) {
                              return _vm.clearErrors("loginPhone")
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "error",
                          class: { show: _vm.serverErrors.loginPhone }
                        },
                        [
                          _c("p", { staticClass: "form-field__err" }, [
                            _vm._v(_vm._s(_vm.serverErrors.loginPhone))
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "login-description" }, [
                      _vm._v(
                        "На указанный мобильный телефон придет СМС с кодом для входа."
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "login-buttons" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button button-gradient",
                        attrs: { disabled: _vm.isLoginLoading, type: "submit" }
                      },
                      [
                        _vm._v(
                          "\n                        Войти по СМС-коду\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button button-colored",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.isEmailLogin = !_vm.isEmailLogin
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Войти с помощью e-mail\n                    "
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.privacyConfirmRequired
            ? _c("div", { staticClass: "form-checkbox rega" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.rega_privacy,
                      expression: "rega_privacy"
                    }
                  ],
                  staticClass: "checkbox",
                  attrs: {
                    id: _vm.form_id + "_privacy",
                    type: "checkbox",
                    checked: "",
                    required: "",
                    name: _vm.form_id + "_privacy"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.rega_privacy)
                      ? _vm._i(_vm.rega_privacy, null) > -1
                      : _vm.rega_privacy
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.rega_privacy,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.rega_privacy = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.rega_privacy = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.rega_privacy = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "label",
                    attrs: { for: _vm.form_id + "_privacy" }
                  },
                  [
                    _vm._v(
                      "\n                Оставляя контактные данные, вы соглашаетесь с "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "privacy-link",
                        attrs: { href: "/documents/privacy/", target: "_blank" }
                      },
                      [
                        _vm._v(
                          "политикой\n                    конфиденциальности"
                        )
                      ]
                    ),
                    _vm._v(
                      " и даете\n                согласние на обработку персональных данных, а также подтверждаете, что "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "privacy-link",
                        attrs: { href: "/documents/eula/", target: "_blank" }
                      },
                      [
                        _vm._v(
                          "Ознакомлены и согласны с\n                    условиями Договора"
                        )
                      ]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(0)
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isAuth,
              expression: "isAuth"
            }
          ],
          staticClass: "auth-form"
        },
        [
          _c("p", { staticClass: "auth-title" }, [
            _vm._v("Вы уже зарегистрированы, подтвердите номер телефона")
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "auth-columns",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.login($event)
                }
              }
            },
            [
              _c("div", { staticClass: "auth-column" }, [
                _c("p", [
                  _vm._v(
                    "Сейчас вы получите код в СМС на номер +7 " +
                      _vm._s(_vm._f("formatPhone")(_vm.rega_phone))
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "auth-column" }, [
                _c("div", { staticClass: "form-field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.code,
                        expression: "code"
                      }
                    ],
                    staticClass: "input",
                    attrs: {
                      name: _vm.form_id + "_code",
                      id: _vm.form_id + "_code",
                      autocomplete: "off",
                      inputmode: "numeric",
                      placeholder: "Код из СМС",
                      maxlength: "4",
                      minlength: "4",
                      required: "",
                      type: "tel"
                    },
                    domProps: { value: _vm.code },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.code = $event.target.value
                        },
                        function($event) {
                          return _vm.clearErrors("code")
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "error",
                      class: { show: _vm.serverErrors.code }
                    },
                    [
                      _c("p", { staticClass: "form-field__err" }, [
                        _vm._v(_vm._s(_vm.serverErrors.code))
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "auth-column" }, [
                _c(
                  "button",
                  {
                    staticClass: "button button-gradient",
                    attrs: { disabled: _vm.isRegLoading, type: "submit" }
                  },
                  [_vm._v("войти")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.timer,
                        expression: "timer"
                      }
                    ],
                    staticClass: "timer"
                  },
                  [
                    _vm._v(
                      "Получить новый код можно будет через " +
                        _vm._s(_vm._f("formatTime")(_vm.timer))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.timer,
                        expression: "!timer"
                      }
                    ],
                    staticClass: "button button-colored",
                    attrs: { type: "button" },
                    on: { click: _vm.sendCode }
                  },
                  [
                    _vm._v(
                      "\n                    отправить код повторно\n                "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.explanationEnabled &&
      (_vm.isShowExplanation || (_vm.isDesktopScreen && !_vm.isTraderPage))
        ? _c("Explanation", {
            staticClass: "explanation",
            attrs: { "is-mobile-view": _vm.isMobileView }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "form-info-list" }, [
      _c("li", { staticClass: "info-item" }, [
        _c("img", {
          staticClass: "info-icon",
          attrs: {
            src: "/img/svg/rega-percent-icon.svg",
            alt: "",
            width: "56",
            height: "56",
            loading: "lazy"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "info-text" }, [
          _vm._v("Определим право на вычет и все доступные льготы для вас")
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "info-item" }, [
        _c("img", {
          staticClass: "info-icon",
          attrs: {
            src: "/img/svg/rega-clipboard-icon.svg",
            alt: "",
            width: "56",
            height: "56",
            loading: "lazy"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "info-text" }, [
          _vm._v("Подготовим список необходимых документов")
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "info-item" }, [
        _c("img", {
          staticClass: "info-icon",
          attrs: {
            src: "/img/svg/rega-shield-icon.svg",
            alt: "",
            width: "56",
            height: "56",
            loading: "lazy"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "info-text" }, [
          _vm._v("Исключим налоговые риски в виде штрафов и требований")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }